module.exports = __webpack_public_path__ + "img/vessel-light-circle.f12096e5.svg";